"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
var theme_1 = require("../theme");
exports.FlexContainer = theme_1.default('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: flex;\n\tflex-direction: ", "\n\tflex-wrap: ", "\n\tjustify-content: ", "\n\talign-items: ", "\n"], ["\n\tdisplay: flex;\n\tflex-direction: ", "\n\tflex-wrap: ", "\n\tjustify-content: ", "\n\talign-items: ", "\n"])), function (props) { return props.flexDirection || 'row'; }, function (props) { return props.flexWrap || 'nowrap'; }, function (props) { return props.justifyContent || 'flex-start'; }, function (props) { return props.alignItems || 'stretch'; });
exports.FlexContainer.displayName = 'FlexContainer';
var templateObject_1;
//# sourceMappingURL=FlexContainer.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@skeoh/pic/out/build/components/FlexContainer.js
// module id = 187
// module chunks = 0